import LanguageButtons from "components/navbar/top/languageBtn";
import React, { useEffect, useState } from "react";
import { Card, Button, Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import axios from "axios";
import paths from "routes/paths";

const PaymentResult = () => {
  const navigate = useNavigate();
  const pathname = window.location.pathname;
  const sessionId = pathname.split("/").pop();
  const { t } = useTranslation();

  const [sessionData, setSessionData] = useState(null);
  const [loading, setLoading] = useState(true);
  //  Helper redirect method to clear session storage first
  const redirect = (path) => {
    sessionStorage.clear();
    navigate(path);
  };

  useEffect(() => {
    let isMounted = true;

    if (!sessionId) return;

    const fetchSessionData = async () => {
      try {
        const resp = await axios.get(
          `${process.env.REACT_APP_PAYMENT_SERVICE_URL}/sessionDataRoute/${sessionId}`,
          {
            headers: {
              Authorization: process.env.REACT_APP_BasicAuthSecret,
            },
          }
        );

        if (isMounted) {
          setSessionData(resp.data);
        }
      } catch (err) {
        console.error("Failed to fetch session data", err);
        if (isMounted) {
          setSessionData({ PaymentStatus: "failed", IsWebhookProcessed: false });
        }
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    fetchSessionData();

    return () => {
      isMounted = false;
    };
  }, [sessionId]);

  if (loading) {
    return (
      <div className="d-flex align-items-center justify-content-center min-vh-100">
        <Spinner animation="border" role="status">
            <span className="visually-hidden">{t("loading")}</span>
        </Spinner>
      </div>
    );
  }

  const isSuccess =
    sessionData &&
    sessionData.PaymentStatus === "paid" &&
    sessionData.IsWebhookProcessed === true;

  const isWebhookPending =
    sessionData &&
    sessionData.PaymentStatus === "paid" &&
    sessionData.IsWebhookProcessed === false;

  return (
    <>
      <div className="language-buttons">
        <LanguageButtons />
      </div>

      <div className="container-fluid d-flex align-items-center justify-content-center min-vh-100">
        <div className="row justify-content-center w-100">
          <div className="col-xxl-3 col-xl-4 col-lg-5 col-md-6 col-sm-8 col-12">
            <Card className="subscription-card">
              <Card.Body className="p-4 p-md-5 text-center">
                <div className="mb-4">
                  {isSuccess ? (
                    <i className="fas fa-check-circle text-success fa-4x"></i>
                  ) : isWebhookPending ? (
                    <i className="fas fa-exclamation-circle text-warning fa-4x"></i>
                  ) : (
                    <i className="fas fa-times-circle text-danger fa-4x"></i>
                  )}
                </div>

                <h4 className="mb-3">
                  {isSuccess
                    ? t("paymentSuccess.success.title")
                    : isWebhookPending
                      ? t("paymentPending.title")
                      : t("paymentFailure.failure.title")}
                </h4>

                <p className="text-muted mb-4">
                  {isSuccess ? (
                    <>
                      {t("paymentSuccess.success.thankMessage")} <br />
                      {t("paymentSuccess.success.description")} <br />
                      {t("paymentSuccess.success.downloadInvoiceText")}{" "}
                      <span
                        className="text-primary fw-semibold text-nowrap"
                        style={{ cursor: "pointer" }}
                        onClick={() => navigate(`${paths.mySubscription}?tab=billing`)}
                      >
                        {t("paymentSuccess.success.clickHere")}
                      </span>
                    </>
                  ) : isWebhookPending ? (
                    <>
                      {t("paymentPending.message1")} <br />
                      {t("paymentPending.message2")}
                    </>
                  ) : (
                    <>
                      {t("paymentFailure.failure.failDescription")} <br />
                      {t("paymentFailure.failure.description")}
                    </>
                  )}
                </p>

                {/* BUTTONS */}
                {isSuccess ? (
                  <Button
                    variant="primary"
                    className="w-100 py-2 payment-button"
                    onClick={() => redirect("/dashboard")}
                  >
                    {t("paymentSuccess.continue.dashboard")}
                  </Button>
                ) : isWebhookPending ? (
                  <Button
                    variant="primary"
                    className="w-100 py-2"
                    onClick={() => redirect("/dashboard")}
                  >
                    {t("paymentPending.goToDashboard")}
                  </Button>
                ) : (
                  <div className="d-grid gap-2">
                    <Button
                      variant="primary"
                      className="py-2"
                      onClick={() => redirect("/subscription/renew-subscription")}
                    >
                      {t("paymentFailure.try.again")}
                    </Button>

                    <Button
                      variant="outline-secondary"
                      className="py-2"
                      onClick={() => redirect("/dashboard")}
                    >
                      {t("paymentFailure.back.dashboard")}
                    </Button>
                  </div>
                )}

              </Card.Body>
            </Card>
          </div>
        </div>
      </div>
    </>
  );
};

export default PaymentResult;
